import { render, staticRenderFns } from "./SimpleMenu.vue?vue&type=template&id=5937e147&scoped=true"
import script from "./SimpleMenu.vue?vue&type=script&lang=js"
export * from "./SimpleMenu.vue?vue&type=script&lang=js"
import style0 from "./SimpleMenu.vue?vue&type=style&index=0&id=5937e147&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5937e147",
  null
  
)

export default component.exports